module.exports = __webpack_public_path__ + "media/images/flags/32/Fiji-3054a3de5c0395cee73f3a1c340f0dfd.png";